import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FILE_TYPES } from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/data/DataTypes';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import api from 'api';
import { DraftContact } from 'models/Contact';
import utils from 'utils';
import GetAndUploadTemplate from 'components/GetAndUploadTemplate';
import useCallbackAsync from 'hooks/useCallbackAsync';
import { SHEET_FILE_TYPES } from 'data/global';

import './UploadBulk.styles.scss';
import './UploadBulk.styles.responsive.scss';

type UploadBulkProps = {
  className?: string;
  onUpload: (contacts: DraftContact[]) => void;
};

const FILE_NAME = 'contacts';

const FIELDS = [
  { field: 'name', description: 'contactNameField' },
  { field: 'email', description: 'email' },
  { field: 'mobilePhone', description: 'mobilePhoneField' },
];

const UploadBulk: React.FC<UploadBulkProps> = (props) => {
  const { className, onUpload } = props;

  const classes = classNames('upload-bulk', 'white-panel', className);

  const { popServerError } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const uploadSheet = useCallback(
    async (file, fileName, config) => {
      try {
        const { data } = await api.contacts.uploadSheet(file, fileName, config);

        onUpload(data);
      } catch (e) {
        popServerError(e);
      }
      return null;
    },
    [onUpload, popServerError],
  );

  const [downloadTemplate, isDownoadingTemplate] = useCallbackAsync(
    async () => {
      const { data } = await api.contacts.getSheetTemplate();

      utils.downloadUrl({
        type: FILE_TYPES.DOCUMENT_XLSX,
        href: data,
      });
    },
  );

  return (
    <div className={classes}>
      <h2>{t('bulkUpload')}</h2>

      <p className="title">{t('uploadContactsToBulkImport')}</p>

      <GetAndUploadTemplate
        fileName={FILE_NAME}
        fields={FIELDS}
        supportedFileTypes={SHEET_FILE_TYPES}
        isDownoadingTemplate={isDownoadingTemplate}
        downloadTemplate={downloadTemplate}
        uploadRequest={uploadSheet}
      />
    </div>
  );
};

export default UploadBulk;
